import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { ContactSearchResults, FetchEntitlementContactParams } from '@atlassian/cssxp-types-contact';
import { Results, ServiceLicense, ServiceLicenseSearchOptions } from '@atlassian/cssxp-typescommon';

const client = createAxiosClient({ baseURL: '/api/1/service-licenses' }, ServiceProxyMap.ANS);

export async function fetchServiceLicense(sen: string): Promise<ServiceLicense> {
  const response = await client.get(`/${sen}`);

  return response.data;
}

export async function fetchContacts(params: FetchEntitlementContactParams): Promise<ContactSearchResults> {
  const { entitlementKey, ...searchOptions } = params;

  const response = await client.get(`/${entitlementKey}/contacts`, {
    params: searchOptions,
  });

  return response.data;
}

export async function searchServiceLicenses(
  query: string,
  searchOptions: ServiceLicenseSearchOptions
): Promise<Results<ServiceLicense>> {
  const defaultSearchOptions = {
    sort: [{ maintenanceActive: 'asc' }, { productName: 'asc' }],
  };

  const response = await client.get('/', {
    params: {
      ...defaultSearchOptions,
      ...searchOptions,
      query,
    },
  });

  return response.data;
}
